import React, { useState, useContext, useEffect } from 'react';
import { AuthContext } from '../../context/AuthContext';
import ConfiguracionImpresion from './ConfiguracionImpresion';

const Configuracion = () => {
  const { currentUser } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState('perfil');
  
  const [perfilForm, setPerfilForm] = useState({
    nombre: currentUser?.nombre || '',
    apellido: currentUser?.apellido || '',
    email: currentUser?.email || '',
    telefono: currentUser?.doctor?.telefono || '',
    direccion: currentUser?.doctor?.direccion || '',
    especialidad: currentUser?.doctor?.especialidad || ''
  });
  
  const [contraseniaForm, setContraseniaForm] = useState({
    contraseniaActual: '',
    nuevaContrasenia: '',
    confirmarContrasenia: ''
  });
  
  const [configuracionClinica, setConfiguracionClinica] = useState({
    nombreClinica: 'Clínica Oftalmológica',
    direccionClinica: 'Av. Principal 123, Quito, Ecuador',
    telefonoClinica: '555-1234',
    horaInicio: '09:00',
    horaFin: '18:00',
    intervalosCitas: '30',
    diasAtencion: ['lunes', 'martes', 'miercoles', 'jueves', 'viernes']
  });
  
  const diasSemana = [
    { id: 'lunes', nombre: 'Lunes' },
    { id: 'martes', nombre: 'Martes' },
    { id: 'miercoles', nombre: 'Miércoles' },
    { id: 'jueves', nombre: 'Jueves' },
    { id: 'viernes', nombre: 'Viernes' },
    { id: 'sabado', nombre: 'Sábado' },
    { id: 'domingo', nombre: 'Domingo' }
  ];
  
  const handlePerfilChange = (e) => {
    setPerfilForm({
      ...perfilForm,
      [e.target.name]: e.target.value
    });
  };
  
  const handleContraseniaChange = (e) => {
    setContraseniaForm({
      ...contraseniaForm,
      [e.target.name]: e.target.value
    });
  };
  
  const handleClinicaChange = (e) => {
    const { name, value } = e.target;
    setConfiguracionClinica({
      ...configuracionClinica,
      [name]: value
    });
  };
  
  const handleDiasAtencionChange = (diaId) => {
    const diasActualizados = configuracionClinica.diasAtencion.includes(diaId)
      ? configuracionClinica.diasAtencion.filter(d => d !== diaId)
      : [...configuracionClinica.diasAtencion, diaId];
    
    setConfiguracionClinica({
      ...configuracionClinica,
      diasAtencion: diasActualizados
    });
  };
  
  const guardarPerfil = (e) => {
    e.preventDefault();
    // Aquí iría la lógica para guardar en la base de datos
    alert('Información de perfil actualizada correctamente');
  };
  
  const cambiarContrasenia = (e) => {
    e.preventDefault();
    
    if (contraseniaForm.nuevaContrasenia !== contraseniaForm.confirmarContrasenia) {
      alert('Las contraseñas no coinciden');
      return;
    }
    
    // Aquí iría la lógica para cambiar la contraseña en la base de datos
    alert('Contraseña actualizada correctamente');
    setContraseniaForm({
      contraseniaActual: '',
      nuevaContrasenia: '',
      confirmarContrasenia: ''
    });
  };
  
  const guardarConfiguracionClinica = (e) => {
    e.preventDefault();
    // Aquí iría la lógica para guardar la configuración en la base de datos
    alert('Configuración de la clínica actualizada correctamente');
  };
  
  return (
    <div style={{ padding: '20px' }}>
      <h2 style={{ marginBottom: '20px' }}>Configuración</h2>
      
      {/* Tabs de navegación */}
      <div style={{ 
        display: 'flex', 
        marginBottom: '20px', 
        borderBottom: '1px solid #ddd'
      }}>
        <div 
          onClick={() => setActiveTab('perfil')} 
          style={{
            padding: '10px 15px',
            cursor: 'pointer',
            borderBottom: activeTab === 'perfil' ? '2px solid #2196f3' : 'none',
            color: activeTab === 'perfil' ? '#2196f3' : '#666',
            fontWeight: activeTab === 'perfil' ? 'bold' : 'normal'
          }}
        >
          Perfil
        </div>
        <div 
          onClick={() => setActiveTab('contrasenia')} 
          style={{
            padding: '10px 15px',
            cursor: 'pointer',
            borderBottom: activeTab === 'contrasenia' ? '2px solid #2196f3' : 'none',
            color: activeTab === 'contrasenia' ? '#2196f3' : '#666',
            fontWeight: activeTab === 'contrasenia' ? 'bold' : 'normal'
          }}
        >
          Contraseña
        </div>
        {currentUser?.rol === 'DOCTOR' && (
          <div 
            onClick={() => setActiveTab('impresion')} 
            style={{
              padding: '10px 15px',
              cursor: 'pointer',
              borderBottom: activeTab === 'impresion' ? '2px solid #2196f3' : 'none',
              color: activeTab === 'impresion' ? '#2196f3' : '#666',
              fontWeight: activeTab === 'impresion' ? 'bold' : 'normal'
            }}
          >
            Información para Impresión
          </div>
        )}
        {currentUser?.rol === 'ADMIN' && (
          <div 
            onClick={() => setActiveTab('clinica')} 
            style={{
              padding: '10px 15px',
              cursor: 'pointer',
              borderBottom: activeTab === 'clinica' ? '2px solid #2196f3' : 'none',
              color: activeTab === 'clinica' ? '#2196f3' : '#666',
              fontWeight: activeTab === 'clinica' ? 'bold' : 'normal'
            }}
          >
            Configuración de la Clínica
          </div>
        )}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '20px' }}>
        {/* Sección de información de perfil */}
        {activeTab === 'perfil' && (
        <div style={{ 
          backgroundColor: 'white', 
          padding: '20px', 
          borderRadius: '8px',
          boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
        }}>
          <h3 style={{ marginTop: '0', marginBottom: '20px' }}>Información de Perfil</h3>
          
          <form onSubmit={guardarPerfil}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#666' }}>
                  Nombre
                </label>
                <input 
                  type="text" 
                  name="nombre"
                  value={perfilForm.nombre}
                  onChange={handlePerfilChange}
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    borderRadius: '4px',
                    border: '1px solid #ddd'
                  }}
                />
              </div>
              
              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#666' }}>
                  Apellido
                </label>
                <input 
                  type="text" 
                  name="apellido"
                  value={perfilForm.apellido}
                  onChange={handlePerfilChange}
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    borderRadius: '4px',
                    border: '1px solid #ddd'
                  }}
                />
              </div>
              
              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#666' }}>
                  Email
                </label>
                <input 
                  type="email" 
                  name="email"
                  value={perfilForm.email}
                  onChange={handlePerfilChange}
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    borderRadius: '4px',
                    border: '1px solid #ddd'
                  }}
                />
              </div>
              
              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#666' }}>
                  Teléfono
                </label>
                <input 
                  type="text" 
                  name="telefono"
                  value={perfilForm.telefono}
                  onChange={handlePerfilChange}
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    borderRadius: '4px',
                    border: '1px solid #ddd'
                  }}
                />
              </div>
              
              <div style={{ gridColumn: '1 / span 2' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#666' }}>
                  Dirección
                </label>
                <input 
                  type="text" 
                  name="direccion"
                  value={perfilForm.direccion}
                  onChange={handlePerfilChange}
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    borderRadius: '4px',
                    border: '1px solid #ddd'
                  }}
                />
              </div>
              
              {currentUser?.rol === 'DOCTOR' && (
                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#666' }}>
                    Especialidad
                  </label>
                  <input 
                    type="text" 
                    name="especialidad"
                    value={perfilForm.especialidad}
                    onChange={handlePerfilChange}
                    style={{
                      width: '100%',
                      padding: '8px 12px',
                      borderRadius: '4px',
                      border: '1px solid #ddd'
                    }}
                  />
                </div>
              )}
            </div>
            
            <div style={{ marginTop: '20px' }}>
              <button 
                type="submit"
                style={{
                  backgroundColor: '#4caf50',
                  color: 'white',
                  border: 'none',
                  padding: '10px 15px',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                Guardar Cambios
              </button>
            </div>
          </form>
        </div>
        )}
        
        {/* Sección de cambio de contraseña */}
        {activeTab === 'contrasenia' && (
        <div style={{ 
          backgroundColor: 'white', 
          padding: '20px', 
          borderRadius: '8px',
          boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
        }}>
          <h3 style={{ marginTop: '0', marginBottom: '20px' }}>Cambiar Contraseña</h3>
          
          <form onSubmit={cambiarContrasenia}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '15px' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#666' }}>
                  Contraseña Actual
                </label>
                <input 
                  type="password" 
                  name="contraseniaActual"
                  value={contraseniaForm.contraseniaActual}
                  onChange={handleContraseniaChange}
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    borderRadius: '4px',
                    border: '1px solid #ddd'
                  }}
                />
              </div>
              
              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#666' }}>
                  Nueva Contraseña
                </label>
                <input 
                  type="password" 
                  name="nuevaContrasenia"
                  value={contraseniaForm.nuevaContrasenia}
                  onChange={handleContraseniaChange}
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    borderRadius: '4px',
                    border: '1px solid #ddd'
                  }}
                />
              </div>
              
              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#666' }}>
                  Confirmar Nueva Contraseña
                </label>
                <input 
                  type="password" 
                  name="confirmarContrasenia"
                  value={contraseniaForm.confirmarContrasenia}
                  onChange={handleContraseniaChange}
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    borderRadius: '4px',
                    border: '1px solid #ddd'
                  }}
                />
              </div>
            </div>
            
            <div style={{ marginTop: '20px' }}>
              <button 
                type="submit"
                style={{
                  backgroundColor: '#2196f3',
                  color: 'white',
                  border: 'none',
                  padding: '10px 15px',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                Cambiar Contraseña
              </button>
            </div>
          </form>
        </div>
        )}
        
        {/* Sección de configuración de impresión */}
        {activeTab === 'impresion' && currentUser?.rol === 'DOCTOR' && (
          <ConfiguracionImpresion />
        )}
        
        {/* Sección de configuración de la clínica (solo para ADMIN) */}
        {activeTab === 'clinica' && currentUser?.rol === 'ADMIN' && (
          <div style={{ 
            backgroundColor: 'white', 
            padding: '20px', 
            borderRadius: '8px',
            boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
          }}>
            <h3 style={{ marginTop: '0', marginBottom: '20px' }}>Configuración de la Clínica</h3>
            
            <form onSubmit={guardarConfiguracionClinica}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                <div style={{ gridColumn: '1 / span 2' }}>
                  <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#666' }}>
                    Nombre de la Clínica
                  </label>
                  <input 
                    type="text" 
                    name="nombreClinica"
                    value={configuracionClinica.nombreClinica}
                    onChange={handleClinicaChange}
                    style={{
                      width: '100%',
                      padding: '8px 12px',
                      borderRadius: '4px',
                      border: '1px solid #ddd'
                    }}
                  />
                </div>
                
                <div style={{ gridColumn: '1 / span 2' }}>
                  <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#666' }}>
                    Dirección
                  </label>
                  <input 
                    type="text" 
                    name="direccionClinica"
                    value={configuracionClinica.direccionClinica}
                    onChange={handleClinicaChange}
                    style={{
                      width: '100%',
                      padding: '8px 12px',
                      borderRadius: '4px',
                      border: '1px solid #ddd'
                    }}
                  />
                </div>
                
                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#666' }}>
                    Teléfono
                  </label>
                  <input 
                    type="text" 
                    name="telefonoClinica"
                    value={configuracionClinica.telefonoClinica}
                    onChange={handleClinicaChange}
                    style={{
                      width: '100%',
                      padding: '8px 12px',
                      borderRadius: '4px',
                      border: '1px solid #ddd'
                    }}
                  />
                </div>
                
                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#666' }}>
                    Intervalo de Citas (minutos)
                  </label>
                  <select 
                    name="intervalosCitas"
                    value={configuracionClinica.intervalosCitas}
                    onChange={handleClinicaChange}
                    style={{
                      width: '100%',
                      padding: '8px 12px',
                      borderRadius: '4px',
                      border: '1px solid #ddd'
                    }}
                  >
                    <option value="15">15 minutos</option>
                    <option value="30">30 minutos</option>
                    <option value="45">45 minutos</option>
                    <option value="60">60 minutos</option>
                  </select>
                </div>
                
                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#666' }}>
                    Hora de Inicio
                  </label>
                  <input 
                    type="time" 
                    name="horaInicio"
                    value={configuracionClinica.horaInicio}
                    onChange={handleClinicaChange}
                    style={{
                      width: '100%',
                      padding: '8px 12px',
                      borderRadius: '4px',
                      border: '1px solid #ddd'
                    }}
                  />
                </div>
                
                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#666' }}>
                    Hora de Fin
                  </label>
                  <input 
                    type="time" 
                    name="horaFin"
                    value={configuracionClinica.horaFin}
                    onChange={handleClinicaChange}
                    style={{
                      width: '100%',
                      padding: '8px 12px',
                      borderRadius: '4px',
                      border: '1px solid #ddd'
                    }}
                  />
                </div>
                
                <div style={{ gridColumn: '1 / span 2' }}>
                  <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', color: '#666' }}>
                    Días de Atención
                  </label>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                    {diasSemana.map(dia => (
                      <div key={dia.id} style={{ display: 'flex', alignItems: 'center' }}>
                        <input 
                          type="checkbox" 
                          id={dia.id}
                          checked={configuracionClinica.diasAtencion.includes(dia.id)}
                          onChange={() => handleDiasAtencionChange(dia.id)}
                          style={{ marginRight: '5px' }}
                        />
                        <label htmlFor={dia.id}>{dia.nombre}</label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              
              <div style={{ marginTop: '20px' }}>
                <button 
                  type="submit"
                  style={{
                    backgroundColor: '#ff9800',
                    color: 'white',
                    border: 'none',
                    padding: '10px 15px',
                    borderRadius: '4px',
                    cursor: 'pointer'
                  }}
                >
                  Guardar Configuración
                </button>
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default Configuracion;